import React, { useCallback, useEffect, useRef, useState } from 'react';

import { MCButton, MCText, View } from 'src/components/basic';
import SVGIcon, { BASE_ICONS, GENERAL_ICONS } from 'src/components/svg';
import FooterInfo from 'src/components/FooterInfo';
import LangSelect from 'src/components/LangSelect';

import { lang, scssVariables, remCss, useScreenDetail } from 'src/helpers';

import MultipleImg from 'src/assets/images/welcome/multiple.png';
import GooglePlayImg from 'src/assets/images/google-play-logo.png';
import AppleImg from 'src/assets/images/apple-logo.png';
import HomeImg from 'src/assets/images/welcome/left.png';
import { AuthHeader } from 'src/components/AuthContainer';
import LANG_CONST from 'src/helpers/lang/const';

export const Header = () => {
  const screen = useScreenDetail();
  const gap = screen.isLargeScreen ? remCss(50) : remCss(20);
  let drawMenu = null;
  const buttons = [
    {
      type: 'link',
      to: '/all',
      label: LANG_CONST.titles.discovery,
      transparent: true,
      hover: false,
      color: 'textLight'
    },
    {
      type: 'link',
      to: '/home_doctor',
      label: LANG_CONST.titles.doctors,
      transparent: true,
      hover: false,
      color: 'textLight'
    },
    {
      type: 'link',
      to: '/home_clinic',
      label: LANG_CONST.titles.clinics,
      transparent: true,
      hover: false,
      color: 'textLight'
    },
    {
      type: 'link',
      to: '/login',
      label: LANG_CONST.buttons.login,
      primary: true,
      light: true,
      color: 'primary'
    }
  ];
  let headerBtn = (
    <>
      <View
        style={{
          flexDirection: 'row',
          flex: 1,
          justifyContent: 'flex-end',
          gap,
          zIndex: 4
        }}
      >
        {buttons.map(({ label, color, ...props }, index) => (
          <View
            key={index}
            style={{
              backgroundColor: props.light ? 'white' : 'transparent',
              borderRadius: remCss(5)
            }}
          >
            <MCButton
              className={!props.light ? 'mc-heading-hover' : ''}
              small
              style={{ paddingLeft: remCss(20), paddingRight: remCss(20) }}
              radius
              {...props}
            >
              <MCText size={25} weight={500} label={label} {...{ [color]: true }} />
            </MCButton>
          </View>
        ))}
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <LangSelect width={remCss(200)} isPopover={!screen.isLargeScreen} />
        </View>
      </View>
    </>
  );

  if (screen.isSmallScreen) {
    headerBtn = null;
    drawMenu = buttons.map(({ label, icon, type, to, onClick }) => ({
      label,
      icon,
      type,
      to,
      onClick
    }));
  }

  return <AuthHeader headerBtn={headerBtn} drawMenu={drawMenu} />;
};

export const MainSection = ({ joinTo, joinText }) => {
  const screen = useScreenDetail();
  const scaleJoinButton = screen.isLargeScreen ? 1 : screen.isMediumScreen ? 0.8 : 0.75;

  return (
    <View
      style={{
        gap: remCss(screen.isSmallScreen ? 10 : 25),
        paddingHorizontal: remCss(screen.isLargeScreen ? 60 : screen.isMediumScreen ? 30 : 0),
        paddingTop: remCss(screen.isSmallScreen ? 30 : 0),
        height: window.innerHeight - 220,
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <View
        style={
          screen.isSmallScreen
            ? { gap: remCss(10) }
            : { flexDirection: 'row', maxWidth: 2000, width: '100%' }
        }
      >
        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
          <img
            src={HomeImg}
            alt={''}
            style={{
              width: '100%',
              maxHeight: (window.innerHeight - 270) / (screen.isSmallScreen ? 2 : 1),
              objectFit: 'contain'
            }}
          />
        </View>
        <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
          <MCButton
            className={'mc-heading-hover'}
            tiny
            style={{
              borderRadius: remCss(70 * scaleJoinButton),
              display: 'flex',
              flexDirection: 'row',
              boxShadow: `0 0 ${remCss(50)}px 0 #00000014`,
              padding: remCss(23 * scaleJoinButton),
              marginVertical: remCss(60 * scaleJoinButton),
              marginHorizontal: 'auto',
              minWidth: 0
            }}
            hover={false}
            type={'link'}
            to={joinTo}
          >
            <SVGIcon iconname={GENERAL_ICONS.ARROW_DOWN} width={90 * scaleJoinButton} />
            <View
              style={{
                paddingLeft: remCss(34 * scaleJoinButton),
                paddingRight: remCss(34 * scaleJoinButton)
              }}
            >
              <MCText
                label={LANG_CONST.buttons.join_app}
                style={{
                  whiteSpace: 'nowrap'
                }}
                size={33 * scaleJoinButton}
                numberOfLines={1}
                textLight
                weight={500}
              />
              <MCText label={joinText} size={30 * scaleJoinButton} textLight />
            </View>
          </MCButton>
        </View>
      </View>
      <div
        className={
          screen.isSmallScreen ? 'mc-primary-930 mc-text-center' : 'mc-primary-942 mc-text-center'
        }
      >
        {lang.t(LANG_CONST.text.welcome_best_app)}
      </div>
    </View>
  );
};

const style = { color: scssVariables['colors-mc-primary'] };
export const features = [
  {
    img: require('src/assets/images/welcome/feature-6.png'),
    content: (
      <>
        Chat with your <span style={style}>doctor any</span> time you need to!
      </>
    )
  },
  {
    img: require('src/assets/images/welcome/feature-3.png'),
    content: (
      <>
        <span style={style}>Pay for your in office</span> visits or video call from home!
      </>
    )
  },
  {
    img: require('src/assets/images/welcome/feature-6.png'),
    content: (
      <>
        Save all your <span style={style}>medical analyses</span> Safe in LifeApp!
      </>
    )
  },
  {
    img: require('src/assets/images/welcome/feature-7.png'),
    content: (
      <>
        <span style={style}>Telemedicine with</span> video calls and video messages
      </>
    )
  },
  {
    img: require('src/assets/images/welcome/feature-3.png'),
    content: (
      <>
        <span style={style}>Medical timeline</span> for each patient
      </>
    )
  }
];

export const FeatureSections = ({ setRefSections, features }) => {
  const screen = useScreenDetail();

  const featureFont = !screen.isLargeScreen ? 36 : 50;

  return features.map((feature, index) => (
    <div key={index} ref={(ref) => setRefSections(ref, index)}>
      {index === 0 && (
        <div className={'mc-text-center mc-plr50 mc-pb50 mc-mb50'}>
          <span className={`mc-primary-9${screen.isSmallScreen ? 42 : 58}`}>
            Telemedicine <span style={{ color: scssVariables['colors-mc-heading'] }}>App</span>
          </span>
        </div>
      )}
      <div
        className={'mc-flex-25 mc-wrap'}
        style={{ flexDirection: index % 2 === 0 ? 'row-reverse' : 'row' }}
      >
        <div className={'mc-grow'} style={{ minWidth: '57%' }}>
          <img
            src={feature.img}
            style={{
              width: '100%',
              maxWidth: remCss(960),
              maxHeight: '90vh',
              objectFit: 'contain'
            }}
          />
        </div>
        <div
          className={'mc-flex-30 mc-flex-start mc-grow'}
          style={{ width: '100%', minWidth: remCss(300) }}
        >
          <div>
            <SVGIcon
              circle
              dark
              padding={5}
              iconname={BASE_ICONS.CHECK}
              width={screen.isSmallScreen ? 40 : 50}
              fill={scssVariables['colors-mc-primary']}
            />
          </div>
          <div className={`mc-value-6${featureFont}`}>{feature.content}</div>
        </div>
      </div>
    </div>
  ));
};

export const Container = ({ mainSection, features = [] }) => {
  const screen = useScreenDetail();
  const refSections = useRef([]);
  const refContainer = useRef(null);
  const [next, setNext] = useState(null);

  const whenScrollWindow = useCallback(() => {
    let nextSection = refSections.current.find(
      (item) =>
        item.offsetTop > window.scrollY + window.innerHeight ||
        item.offsetTop + item.offsetHeight > window.scrollY + window.innerHeight + 100
    );

    setNext(nextSection);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', whenScrollWindow);
    whenScrollWindow();
    return () => window.removeEventListener('scroll', whenScrollWindow);
  }, [whenScrollWindow]);

  const scroll = () => {
    if (!next)
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    else {
      next.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      });
    }
  };

  return (
    <View style={{ backgroundColor: 'white' }}>
      <View
        ref={refContainer}
        style={{
          maxWidth: Number(scssVariables['width-max']),
          position: 'relative',
          marginHorizontal: 'auto'
        }}
      >
        <Header />
        <View style={{ gap: remCss(120) }}>
          <View ref={(ref) => (refSections.current[0] = ref)}>{mainSection}</View>
          {!!features.length && (
            <View
              style={{
                padding: 0,
                gap: remCss(50),
                marginHorizontal: screen.isSmallScreen ? remCss(15) : '7%'
              }}
            >
              <FeatureSections
                setRefSections={(ref, index) => (refSections.current[index + 1] = ref)}
                features={features}
              />
            </View>
          )}

          <View
            style={{
              padding: 0,
              gap: remCss(50),
              marginHorizontal: screen.isSmallScreen ? 0 : '7%'
            }}
            ref={(ref) => (refSections.current[features.length + 1] = ref)}
          >
            <div className={'mc-text-center mc-plr50'}>
              <span className={'mc-value-650'}>Furthermore, LifeApp is the </span>
              <span className={'mc-primary-650'}> Mobile-first design</span>
            </div>
            <img
              src={MultipleImg}
              style={{
                width: '100%',
                minWidth: remCss(550 * (screen.isSmallScreen ? 0.5 : 1)),
                maxHeight: '90vh',
                objectFit: 'contain'
              }}
            />
          </View>
          <View style={{ padding: 0, gap: remCss(50) }}>
            <div className={'mc-text-center mc-plr50'}>
              <span className={'mc-value-650'}>Download</span>
              <span className={'mc-primary-650'}> mobile </span>
              <span className={'mc-value-650'}>app</span>
            </div>
            <div className={'mc-flex-20 '} style={{ justifyContent: 'center' }}>
              <a
                className={'mc-no-style-btn'}
                href={'https://play.google.com/apps/test/ai.lifeapp/9'}
              >
                <img width={remCss(300 * (screen.isSmallScreen ? 0.5 : 1))} src={GooglePlayImg} />
              </a>
              <a className={'mc-no-style-btn'} href={'https://apps.apple.com/'}>
                <img width={remCss(300 * (screen.isSmallScreen ? 0.5 : 1))} src={AppleImg} />
              </a>
            </div>
          </View>
          <View
            style={{
              position: 'sticky',
              bottom: remCss(20),
              zIndex: 2,
              height: 0,
              alignItems: 'center'
            }}
          >
            {next ? (
              <button className={'mc-scroll-down'} onClick={scroll}>
                <SVGIcon iconname={GENERAL_ICONS.ARROW_DOWN} width={35} />
                <span className={'mc-label-520'}>{lang.t(LANG_CONST.buttons.scroll_down)}</span>
              </button>
            ) : (
              <button className={'mc-scroll-down'} onClick={scroll}>
                <span className={'mc-rotate mc-rotate-180'}>
                  <SVGIcon iconname={GENERAL_ICONS.ARROW_DOWN} width={35} />
                </span>
                <span className={'mc-label-520'}>{lang.t(LANG_CONST.buttons.scroll_top)}</span>
              </button>
            )}
          </View>
          <View ref={(ref) => (refSections.current[features.length + 2] = ref)}>
            <FooterInfo isRotate={screen.isSmallScreen} />
          </View>
        </View>
      </View>
    </View>
  );
};
